import get from 'lodash/get';
import defaultFields from 'store/Host/fields';

export const selectFields = (state) => {
  const fields = get(state, 'preferences.host_table', defaultFields);
  const newFields = {};
  Object.keys(defaultFields).forEach((key) => {
    const defaultField = defaultFields[key];
    const field = get(fields, key, defaultField);
    newFields[key] = {
      ...defaultField,
      ...field
    };
  });
  return newFields;
};

export const selectHostList = (state) => get(state, 'host.hostList', []);
